import { useQuery } from '@tanstack/react-query';
import {
  type NotificationReason,
  configControllerGetPublicProductConfigQueryOptions,
  notificationReasonEnum,
} from 'korint-sdk';

export function useSendableNotificationReasons(productId: string): NotificationReason[] {
  const { data = [] } = useQuery({
    ...configControllerGetPublicProductConfigQueryOptions(productId),
    select: ({ isFormalNoticeEnabled, isNonRenewalEnabled }): NotificationReason[] => [
      ...(isFormalNoticeEnabled ? [notificationReasonEnum.FORMAL_NOTICE] : []),
      ...(isNonRenewalEnabled ? [notificationReasonEnum.NON_RENEWAL] : []),
    ],
  });
  return data;
}
